import {Component, Input, OnInit} from '@angular/core';
import {Paths} from '../../../config/config';

@Component({
  selector: 'app-box-kit',
  templateUrl: './box-kit.component.html',
  styleUrls: ['./box-kit.component.scss']
})
export class BoxKitComponent implements OnInit {

  @Input() serie;
  @Input() name;
  @Input() phiInfo;
  @Input() slug;
  @Input() img;
  @Input() productSlug?: string;

  public readonly Paths = Paths;

  constructor() {
  }

  ngOnInit() {
  }

  public getQueryParams(labelProduct: string): object {
    if (this.productSlug) {
      return {
        ['prodotto']: this.productSlug
      };
    }
    return {};
  }

}
